import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ChaptersSection } from './components/ChaptersSection';
import { HowItWorks } from './components/HowItWorks';
import { PricingSection } from './components/PricingSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen flex flex-col w-full selection:bg-gold/30 selection:text-navy-dark" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <ChaptersSection data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <PricingSection data-id="element-6" />
        <CtaSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}